import { motion } from 'framer-motion';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';

const BusinessPlanningPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-16 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-4xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="inline-block mb-6 px-5 py-2 border border-red/20 bg-red/5 rounded-full">
                <span className="text-red text-sm font-medium">事業計画</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                事業計画をつくるのはこんな感じです
              </h1>
            </motion.div>
          </div>
        </section>

        {/* Article Content */}
        <article className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="prose prose-lg max-w-none"
            >
              <div className="space-y-8 text-gray-700 leading-relaxed text-[17px]">
                <p>
                  事業計画をつくるとか言われても
                </p>

                <div className="text-center text-3xl font-bold text-gray-400 my-8">
                  ？？？？？
                </div>

                <p>
                  という人は多いと思いますので
                </p>

                <p>
                  Facebookでシェアした内容の転載しました。<br />
                  以下facebookの内容です
                </p>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">事業計画つくるのこんな感じです</h2>
                  <div className="flex items-start gap-4 bg-white/50 rounded-xl p-6">
                    <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-lightbulb-line text-red text-xl"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900 mb-2">会計士の基本方針</p>
                      <p>
                        ちなみに私(会計士）は答えはいわずに考えて、社長が自分で銀行等に事業の説明できるようにするのが基本方針です。
                      </p>
                    </div>
                  </div>
                </div>

                <div className="border-l-4 border-red bg-gray-50 rounded-r-2xl p-8 my-10">
                  <div className="flex items-start gap-3 mb-6">
                    <div className="w-10 h-10 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-user-line text-red"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mt-1">お客様の声</h3>
                  </div>
                  
                  <div className="space-y-6">
                    <div>
                      <h4 className="text-lg font-bold text-gray-900 mb-3">【今日もやりきったかい？】</h4>
                      <p className="mb-4">
                        本日は、正午から、会計士の赤石先生との打ち合わせから始まりーの。その後も2店舗目の詳細詰め・千中店の分析やら計画にと、ノンストップでしたψ(｀∇´)ψ★
                      </p>
                      <p className="mb-4">
                        クタクタでしゅ♪(´ε｀ )笑
                      </p>
                    </div>

                    <div className="bg-white rounded-xl p-6 shadow-sm">
                      <p className="mb-4">
                        もう今日は家に帰ろうかと思いましたが<br />
                        『おまえ、今日もやりきったかい？』<br />
                        と自分に聞いたら『まだまだいける！』と声が聞こえたので(笑)
                      </p>
                      <p className="mb-4">
                        本日の締めに、今から店舗出勤します〜<br />
                        皆来て〜(笑)
                      </p>
                    </div>

                    <div>
                      <p className="mb-4">
                        今のうちに、自身と従業員の更なる現場力強化に尽力しますψ(｀∇´)ψ
                      </p>
                      <p className="mb-4">
                        さー、まだまだ今日もガンガンいきまっせ〜〜(((o(*ﾟ▽ﾟ*)o)))
                      </p>
                      <p className="font-medium text-gray-900">
                        本日も美味しいビール呑むためにがんばるぞ〜
                      </p>
                    </div>

                    <div className="mt-6">
                      <img
                        src="https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/445c0c5cfd2ca053ab9221e39788fd8b.jpeg"
                        alt="事業計画の打ち合わせ"
                        className="w-full h-auto rounded-xl shadow-lg"
                      />
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-2xl p-8 border border-red/10 my-10">
                  <h2 className="text-2xl font-bold text-gray-900 mb-6">事業計画作成のポイント</h2>
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">自分で考える</strong>
                        <p className="text-gray-600 mt-1">会計士は答えを教えるのではなく、社長自身が考えるサポートをします</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">説明できる力</strong>
                        <p className="text-gray-600 mt-1">銀行などに自分の言葉で事業を説明できるようになることが重要です</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">詳細な分析</strong>
                        <p className="text-gray-600 mt-1">店舗の分析や計画を丁寧に詰めていくことで、実現可能な計画が生まれます</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                        <i className="ri-check-line text-red"></i>
                      </div>
                      <div>
                        <strong className="text-gray-900">やりきる姿勢</strong>
                        <p className="text-gray-600 mt-1">事業計画は作って終わりではなく、実行し続ける姿勢が大切です</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-200 pt-8 mt-12">
                  <p className="text-gray-600">
                    事業計画は難しく考える必要はありません。会計士と一緒に、自分の事業を見つめ直し、将来のビジョンを明確にしていく。そのプロセスこそが、事業計画作成の本質です。
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
        </article>

        {/* Related Articles */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl font-bold text-gray-900 mb-10 text-center">関連記事</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <a
                href="/blog/company-history-profile"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/company-history-profile');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://public.readdy.ai/ai/img_res/078a2e67b8da06ee706de50aa4613620.jpg"
                    alt="会社の沿革"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    会社の沿革
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    会社の沿革、経営者のプロフィールは重要
                  </h3>
                </div>
              </a>

              <a
                href="/blog/multiple-income"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/multiple-income');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=multiple%20income%20streams%20concept%20with%20financial%20documents%20and%20calculator%2C%20organized%20tax%20preparation%20materials%20on%20modern%20desk%2C%20professional%20accounting%20workspace%20with%20clean%20aesthetic%2C%20business%20photography%20emphasizing%20financial%20management&width=800&height=500&seq=blog-003&orientation=landscape"
                    alt="確定申告"
                    className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    確定申告
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    複数の収入をもつ
                  </h3>
                </div>
              </a>

              <a
                href="/blog/cash-register-management"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/cash-register-management');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20cash%20register%20and%20financial%20management%20system%20in%20retail%20setting%2C%20organized%20point%20of%20sale%20workspace%20with%20clean%20professional%20aesthetic%2C%20business%20technology%20with%20natural%20lighting%2C%20commercial%20photography%20emphasizing%20efficiency%20and%20accuracy&width=800&height=500&seq=blog-004&orientation=landscape"
                    alt="現金管理"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    現金管理
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    レジ現金管理
                  </h3>
                </div>
              </a>

              <a
                href="/blog/depreciation"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/blog/depreciation');
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }, 100);
                }}
                className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=depreciation%20concept%20with%20business%20assets%20and%20financial%20calculations%2C%20professional%20accounting%20documents%20on%20modern%20desk%2C%20clean%20office%20environment%20with%20natural%20lighting%2C%20business%20photography%20emphasizing%20financial%20planning%20and%20asset%20management&width=800&height=500&seq=blog-005&orientation=landscape"
                    alt="減価償却"
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="inline-block mb-3 bg-red text-white px-3 py-1 rounded-full text-xs font-medium">
                    税務
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 group-hover:text-red transition-colors">
                    減価償却
                  </h3>
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-red-dark to-red">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl font-bold text-white mb-6">
                事業計画作成をサポートします
              </h2>
              <p className="text-white/90 mb-10 text-lg leading-relaxed">
                あなたの事業の可能性を最大限に引き出す事業計画を、<br />
                一緒に作り上げていきましょう。
              </p>
              <a
                href="/#contact"
                onClick={(e) => {
                  e.preventDefault();
                  window.REACT_APP_NAVIGATE('/');
                  setTimeout(() => {
                    const element = document.getElementById('contact');
                    if (element) {
                      element.scrollIntoView({ behavior: 'smooth' });
                    }
                  }, 100);
                }}
                className="inline-block bg-white text-red px-12 py-4 rounded-full text-[15px] font-medium hover:bg-gray-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-xl"
              >
                無料相談を予約する
              </a>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default BusinessPlanningPage;